const RespondentSettingsData = {
    types_of_graph: [
        {
            value: "LINE",
            label: "Line",
        },
        {
            value: "PIE",
            label: "Pie",
        },
        // {
        //     value: "BAR",
        //     label: "Bar",
        // },
        {
            value: "HORIZONTAL_BAR",
            label: "Horizontal Bar",
        },
        {
            value: "VERTICAL_BAR",
            label: "Vertical Bar",
        },
        {
            value: "FULL_DONUT",
            label: "Full Donut",
        },
        {
            value: "HALF_DONUT",
            label: "Half Donut",
        },
        // {
        //     value: "DEFAULT",
        //     label: "Default",
        // },
        // {
        //     value: "TABLE",
        //     label: "Table",
        // },
    ],
    types_of_variable: [
        {
            value: "RECALL",
            label: "Recall",
        },
        {
            value: "SCREENER",
            label: "Screener",
        },
        {
            value: "ADDITIONAL_PRODUCT_PERFORMANCE",
            label: "Additional Product Performance",
        },
    ],
};
export default RespondentSettingsData;
